
import { motion } from 'framer-motion';
import './Hero.css';
import flat3 from '../assets/Residential/Apartment/flat4.png';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay hero-flex">
        <div className="hero-left">
          <div className="hero-content">
            <motion.h1 
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Designing Space. Defining Style. Delivering Vision.
            </motion.h1>
            <motion.h2
              className="hero-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
            >
              Welcome to 10 Designs – where architecture meets imagination.
            </motion.h2>
            <motion.p
              className="hero-intro"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2 }}
            >
              We are a Hyderabad-based design studio that brings together architecture, interiors, and landscape under one creative roof. With a focus on smart planning, clean aesthetics, and future-ready solutions, we turn ideas into iconic spaces—residential, commercial, and industrial alike.<br/>
              Whether you're building a dream home, designing a dynamic office, or shaping an efficient industrial unit, we approach each project with clarity, creativity, and care.
            </motion.p>
          </div>
        </div>
        <div className="hero-right">
          <img 
            src={flat3}
            alt="Modern Villa Architecture" 
            className="hero-img-right"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero; 